import { render, staticRenderFns } from "./GoodsModelModal.vue?vue&type=template&id=2c2efb08&scoped=true"
import script from "./GoodsModelModal.vue?vue&type=script&lang=js"
export * from "./GoodsModelModal.vue?vue&type=script&lang=js"
import style0 from "./GoodsModelModal.vue?vue&type=style&index=0&id=2c2efb08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2efb08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2efb08')) {
      api.createRecord('2c2efb08', component.options)
    } else {
      api.reload('2c2efb08', component.options)
    }
    module.hot.accept("./GoodsModelModal.vue?vue&type=template&id=2c2efb08&scoped=true", function () {
      api.rerender('2c2efb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/GoodsModelModal.vue"
export default component.exports